module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Food/Cookie-57ccd046628a257af728e07068e2c101.svg";